import Notiflix from "notiflix-react";


export function configuration(width,position,distance,opacity,borderRadius,rtl,timeout,messageMaxLength,
    backOverlay,backOverlayColor,ID,className,zindex,useGoogleFont,fontFamily,fontSize,cssAnimation,
    cssAnimationDuration,cssAnimationStyle,closeButton,useIcon,useFontAwesome,fontAwesomeIconStyle,
    fontAwesomeIconSize,plainText) {

    const notiflix = Notiflix;
    notiflix.Notify.Init({
        width: width,
        position: position, // 'right-top' - 'right-bottom' - 'left-top' - 'left-bottom' 
        distance: distance,
        opacity: opacity,
        borderRadius: borderRadius,
        rtl: rtl,
        timeout: timeout,
        messageMaxLength: messageMaxLength,
        backOverlay: backOverlay,
        backOverlayColor: backOverlayColor,

        ID: ID,
        className: className,
        zindex: zindex,
        useGoogleFont: useGoogleFont,
        fontFamily: fontFamily,
        fontSize: fontSize,
        cssAnimation: cssAnimation,
        cssAnimationDuration: cssAnimationDuration,
        cssAnimationStyle: cssAnimationStyle, // 'zoom' - 'fade' - 'from-right' - 'from-top' - 'from-bottom' - 'from-left'
        closeButton: closeButton,
        useIcon: useIcon,
        useFontAwesome: useFontAwesome,
        fontAwesomeIconStyle: fontAwesomeIconStyle, // 'shadow' - 'basic'
        fontAwesomeIconSize: fontAwesomeIconSize,
        plainText: plainText,

        // success: {
        //     svgColor: '#00b462',
        //     titleColor: '#1e1e1e',
        //     messageColor: '#242424',
        //     buttonBackground: '#00b462',
        //     buttonColor: '#fff',
        // },

        // failure: {
        //     background: '#ff5549',
        //     textColor: '#fff',
        //     childClassName: 'failure',
        //     notiflixIconColor: 'rgba(0,0,0,0.2)',
        //     fontAwesomeClassName: 'fas fa-times-circle',
        //     fontAwesomeIconColor: 'rgba(0,0,0,0.2)',
        // },

        // warning: {
        //     background: '#eebf31',
        //     textColor: '#fff',
        //     childClassName: 'warning',
        //     notiflixIconColor: 'rgba(0,0,0,0.2)',
        //     fontAwesomeClassName: 'fas fa-exclamation-circle',
        //     fontAwesomeIconColor: 'rgba(0,0,0,0.2)',
        // },

        // info: {
        //     background: '#26c0d3',
        //     textColor: '#fff',
        //     childClassName: 'info',
        //     notiflixIconColor: 'rgba(0,0,0,0.2)',
        //     fontAwesomeClassName: 'fas fa-info-circle',
        //     fontAwesomeIconColor: 'rgba(0,0,0,0.2)',
        // },


    })

    return notiflix;
}

